<template>
  
<div>
 <b-navbar class="box-shadow navbar-fixed-top" toggleable="lg" type="light" variant="light">
        <!-- Brand demo (see demo.css) -->


    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-navbar-brand
        to="/"
        class="app-brand demo py-0"
      >
        <img
          class="header-img mb-1"
          :src="`${publicUrl}img/logo/eines-logo.svg`"
          alt
        />
      </b-navbar-brand>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>

      </b-navbar-nav>

      <div class="col-md-6 col-lg-6 col-xl-5 d-none d-lg-block">

          
      </div>
          

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-form>
      
        </b-nav-form>

        <div>

          <b-nav-item-dropdown right>
                <template slot="button-content">
                  {{ $t('text1.language') }}
                </template>
                <b-dropdown-item v-on:click="changeLanguageEN">English </b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageCN">Chinese (中文)</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageNO">Norsk</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageFR">Français</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageIS">Íslensku</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageJP">Japanese (日本人)</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguagePL">Polskie</b-dropdown-item>
            </b-nav-item-dropdown>

        </div>

        <b-button v-if="isLoggedIn == true" variant="primary" @click="goDashboard">Go to dashboard</b-button>
        
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  </div>

</template>

<script>
  import axios from "axios";

  export default {
  components: {
      
    },
  data () {
    return {}
  },
  methods: {
    goDashboard() {
        this.$router.push("/admin/dashboard");
    },

    logout: function() {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/");
        })
      },
      changeLanguageNO() {
        this.$i18n.locale = 'no'
      },
      changeLanguageEN() {
        this.$i18n.locale = 'en'
      },
      changeLanguageFR() {
        this.$i18n.locale = 'fr'
      },
      changeLanguageIS() {
        this.$i18n.locale = 'is'
      },
      changeLanguageCN() {
        this.$i18n.locale = 'cn'
      },
      changeLanguagePL() {
        this.$i18n.locale = 'pl'
      },
      changeLanguageJP() {
        this.$i18n.locale = 'jp'
      }
    },
    computed: {
      isLoggedIn: function() {
        return this.$store.getters.isLoggedIn;
      },
    }
  }
</script>

<style lang="css" scoped>



/* Navbar styles  */

.company-logo {
  max-width: 250px;
}


.navbar {
  background-color: #ffffff !important;
  border-bottom: 1px solid #e5e5e5;
}

.navbar-light .navbar-nav .nav-link {
    color: #070a57 !important;
}


.dropdown-color {
  color: #070a57 !important;
}

.box-shadow {
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, .02);
}

.bg-light {
    background-color: #ffffff !important;
}

.bg-info {
    background-color: #17a2b8!important;
}

  @media (min-width: 576px) {
   
  }

  @media (min-width: 768px) {
    .navbar {
    height: 8vh !important;
    }
  }

  @media (min-width: 1024px) {
    .navbar {
    height: 8vh !important;
    }
  }

  @media (min-width: 1250px) {
     .navbar {
    height: 8vh !important;
    }
    }

  @media (min-width: 1650px) {
    .navbar {
    height: 8vh !important;
    }
  }


</style>